import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { MortalityProvider } from './contexts/MortalityContext';
import './index.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find root element');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <AuthProvider>
      <MortalityProvider>
        <App />
      </MortalityProvider>
    </AuthProvider>
  </React.StrictMode>,
);
